import { toast } from "react-toastify";
// import noimage from "../assets/Images/noImage.png";
import { useLocation, useSearchParams } from "react-router-dom";
import show from "../../components/toastOverridetoast";


export default function capitalizeFirst(str: String) {
  if (!str) return "";
  return str.match("^[a-z]")
    ? str.charAt(0).toUpperCase() + str.substring(1)
    : str;
}



// error message toast
export const errorMsg = (message: any) => {
  show.error(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
  });
};

// success message toast
export const successMsg = (message: any) => {
  show.success(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
  });
};

export const imageOnErrorHandler = (
  event: React.SyntheticEvent<HTMLImageElement, Event>
) => {
  // event.currentTarget.src = noimage;
  event.currentTarget.className = "error";
};

export const imageHandler = (image: any) => {
  let base_url = localStorage.getItem("base_url")
  if (!image) {
    return ;
  } else {
    if (image.indexOf("http://") == 0 || image.indexOf("https://") == 0) {
      return image;
    } else {
      return base_url + image;
    }
  }
}

export const getOrgIdLocal = () =>{
  return localStorage.getItem("org_instance_id") 
} 

export const language = () => {
  let language = localStorage.getItem("language");
  return language as string || "en";
}

export const confirm = () => {
  let language = localStorage.getItem("language");

  let data = [];
  if (language as string == "en" || language == null) {
    data.push({
      name: "Yes",
      value: 1
    },
      {
        name: "No",
        value: 0
      })

  } else {
    data.push({
      name: "ஆம்",
      value: 1
    },
      {
        name: "இல்லை",
        value: 0
      })
  }

  return data;

}



export const HouseType = () => {
  let language = localStorage.getItem("language");

  let data = [];
  if (language as string == "en" || language == null) {
    data.push(
      {
        name: "Own",
        value: 1
      },
      {
        name: "Rent",
        value: 2
      },
      {
        name: "Lease",
        value: 3
      }
    )

  } else {
    data.push(
      {
        name: "சொந்தம்",
        value: 1
      },
      {
        name: "வாடகை",
        value: 2
      },
      {
        name: "குத்தகைக்கு",
        value: 3
      }
    )
  }

  return data;

}

export const BuildingType = () => {
  let language = localStorage.getItem("language");

  let data = [];
  if (language as string == "en" || language == null) {
    data.push(
      {
        name: "Concrete",
        value: 1
      },
      {
        name: "Others",
        value: 2
      }
    )

  } else {
    data.push(
      {
        name: "கான்கிரீட்",
        value: 1
      },
      {
        name: "மற்றவைகள்",
        value: 2
      }
    )
  }

  return data;

}

export function getUserId(){
  let location = useLocation();
  let keyValue:any = location.pathname.substring(location.pathname.lastIndexOf("/") + 1);

    if (keyValue == undefined || keyValue == null  ){
         keyValue = localStorage.getItem("user_id")
    }
    return keyValue
}

const country_labels = [
  { country: "94", zip_code: "Pincode", zip_code_format: "numbers_only", MRP: "MRP", currency :"₹" , dial_country_code:"in"},
  { country: "216", zip_code: "Postcode", zip_code_format: "alphanumeric", MRP: "RRP", currency :"£", dial_country_code:"gb" },
  {country: "192", zip_code: "Postal Code", zip_code_format: "alphanumeric", MRP: "RSP",  currency :"$", dial_country_code:"LK" },
  {country: "184", zip_code: "Pincode", zip_code_format: "numbers_only", MRP: "MRP",  currency :"S$", dial_country_code:"SGD" }
];

export function  getCountryDataById(id:any) {
  return country_labels.find(country => country?.country === id);
}